import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import ebidImage from "../../assets/images/logo.svg";

function FooterbarForPages() {
    return (
        <footer className="bg-[rgb(230,242,242)] dark:bg-gray-900 border-t supports-[backdrop-filter]:bg-background/60">
            <div className="container px-4 py-8 mx-auto">
                <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <img src={ebidImage} alt="GlobalsBid" className="h-10 object-contain" />
                        <p className="text-sm text-gray-700 dark:text-gray-300 max-w-xs">
                            Your trusted partner in global tender opportunities.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="space-y-4">
                        {/* <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Quick Links</h3>
                        <ul className="space-y-2">
                            {[
                                { name: "Privacy Policy", path: "/privacy-policy" },
                                { name: "Terms of Service", path: "/terms-and-conditions" },
                                { name: "Refund Policy", path: "/refund-policy" }
                            ].map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.path}
                                        className="text-sm text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul> */}
                    </div>

                    {/* Contact Info */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Contact Us</h3>
                        <ul className="space-y-3">
                            {[
                                {
                                    type: 'Sales',
                                    email: 'sales@globalsbid.com',
                                    icon: <Mail className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                                },
                                {
                                    type: 'Support',
                                    email: 'support@globalsbid.com',
                                    icon: <Mail className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                                },
                                {
                                    type: 'Phone',
                                    email: '(+91) 7276979336',
                                    icon: <Phone className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                                }
                            ]?.map((contact) => (
                                <li key={contact.type} className="flex items-center space-x-2">
                                    {contact.icon}
                                    <a
                                        href={contact.type.includes('Email') ? `mailto:${contact.email}` : `tel:${contact.email}`}
                                        className="text-sm text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400"
                                    >
                                        {contact.email}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                    <p className="text-xs text-center text-gray-600 dark:text-gray-400">
                        © {new Date().getFullYear()} GlobalsBid. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default FooterbarForPages; 